import React from 'react';
import { Banner, Text } from '@usealloy/component-library';
import styled from 'styled-components';

const FullWidthBanner = styled(Banner).attrs(p => ({
  open: true,
  variant: p.variant || 'info',
}))`
  &&& {
    border-radius: 0;
  }
`;

const TopOfPageBanner: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <FullWidthBanner>
    <Text>
      {children}
    </Text>
  </FullWidthBanner>
);

export default TopOfPageBanner;
